import { Injectable } from '@angular/core';
import { NbThemeService, NbToastrService } from '@nebular/theme';


@Injectable({
  providedIn: 'root'
})
export class UtilidadesService {

  constructor(private toastrService: NbToastrService){
    
  }

  notificationWarning(titulo,mensaje,position) {
    this.toastrService.warning(mensaje,titulo,{position});
  }

  notificationSuccess(titulo,mensaje,position) {
    this.toastrService.success(mensaje,titulo,{position});
  }

  formatoFecha(fecha){
    let array: Array<any> = fecha.split("-",3);
    return {day:Number(array[2]),month:Number(array[1]),year:Number(array[0])};
   }

}
